<template>
  <div class="drawer">
    <div class="drawer-container">
      <el-tabs v-model="activeName" @tab-click="handleClickTab">
        <el-tab-pane :label="$t('bargain.bargainInfo')" name="detail">
          <div class="drawer-content with-tab">
            <el-form
              ref="bargainForm"
              :model="bargain"
              class="box"
              label-width="100px"
            >
              <fieldset class="mgb15">
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('bargain.serialNo')">
                      {{ bargain.serialNo }}
                    </el-form-item>
                  </el-col>
                  <el-col v-if="Permit.canActions('globalSalePrice')" :span="8">
                    <el-form-item :label="$t('bargain.saleAmount')">
                      <currency :code="bargain.currency"></currency>
                      {{ bargain.productAmount }}
                    </el-form-item>
                  </el-col>
                  <el-col v-if="Permit.canActions('globalSalePrice')" :span="8">
                    <el-form-item :label="$t('bargain.amount')">
                      <currency :code="bargain.currency"></currency>
                      {{ bargain.amount }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col v-if="Permit.canActions('globalSalePrice')" :span="8">
                    <el-form-item :label="$t('bargain.payAmount')">
                      <span v-if="bargain.settleType == 'later'">{{
                        $t("settleTypes.later")
                      }}</span>
                      <span v-else>
                        <span class="mgr5">
                          <span v-if="bargain.ignoreAmount !== 0"
                            >{{ $t("bargain.receive") }}:</span
                          >
                          <currency :code="bargain.currency"></currency>
                          {{ bargain.payAmount }}
                        </span>
                        <span v-if="bargain.ignoreAmount > 0" class="mr5">
                          {{ $t("bargain.ignore") }}:
                          <currency :code="bargain.currency"></currency>
                          {{ bargain.ignoreAmount }}
                        </span>
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('user.shop')">
                      {{ bargain.shopName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.owner')">
                      {{ bargain.ownerName }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item :label="$t('text.createAt')">
                      {{ bargain.createAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-form-item :label="$t('bargain.deliveryRemark')">
                      {{ bargain.deliveryRemark }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset
                v-if="bargain.remark != null && bargain.remark != ''"
                class="mgb15"
              >
                <legend>{{ $t("text.remark") }}</legend>
                <raw-html :content="bargain.remark" />
              </fieldset>
              <fieldset class="mgb10">
                <legend>{{ $t("bargain.customerInfo") }}</legend>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('bargain.customerName')">
                      <span
                        v-if="
                          bargain.replaceCustomerId != null &&
                          bargain.customer != null
                        "
                        >{{ bargain.customer.name }}</span
                      >
                      <span v-else>{{ bargain.customerName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('bargain.customerPhone')">
                      <span
                        v-if="
                          bargain.replaceCustomerId != null &&
                          bargain.customer != null
                        "
                        >{{ bargain.customer.phone }}</span
                      >
                      <span v-else>{{ bargain.customerPhone }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('bargain.customerZipcode')">
                      <span
                        v-if="
                          bargain.replaceCustomerId != null &&
                          bargain.customer != null
                        "
                        >{{ bargain.customer.zipcode }}</span
                      >
                      <span v-else>{{ bargain.customerZipcode }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="24">
                    <el-form-item :label="$t('bargain.customerAddress')">
                      <span
                        v-if="
                          bargain.replaceCustomerId != null &&
                          bargain.customer != null
                        "
                      >
                        <span v-if="bargain.customer.country != null">{{
                          $t("countries." + bargain.customer.country)
                        }}</span>
                        {{ bargain.customer.province }}{{ bargain.customer.city
                        }}{{ bargain.customer.address }}
                      </span>
                      <span v-else>
                        <span v-if="bargain.customerCountry != null">
                          {{ $t("countries." + bargain.customerCountry) }}
                        </span>
                        {{ bargain.customerProvince }}{{ bargain.customerCity
                        }}{{ bargain.customerAddress }}
                      </span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset
                v-if="
                  Permit.canActions('orderPaymentView') &&
                  bargain.settleType == 'now'
                "
                class="mgb10"
              >
                <legend>
                  {{ $t("bargain.paymentInfo") }}
                  <span class="float-right mgr10">
                    <span class="mgr5">
                      {{ $t("bargain.receive") }}:
                      <currency :code="bargain.currency"></currency>
                      {{ bargain.payAmount }}
                    </span>
                    <span v-if="bargain.ignoreAmount > 0" class="mr5">
                      {{ $t("bargain.ignore") }}:
                      <currency :code="bargain.currency"></currency>
                      {{ bargain.ignoreAmount }}
                    </span>
                  </span>
                </legend>
                <vxe-table
                  :data="bargain.payments"
                  size="mini"
                  highlight-hover-row
                  :scroll-y="{ enabled: false }"
                >
                  <vxe-table-column field="total" :title="$t('payment.total')">
                    <template v-slot="{ row }">
                      <currency :code="row.currency"></currency>
                      {{ row.total }}
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="payMethodName"
                    :title="$t('payment.payMethod')"
                  ></vxe-table-column>
                  <vxe-table-column
                    field="paidAt"
                    :title="$t('payment.paidAt')"
                    width="110px"
                  ></vxe-table-column>
                  <vxe-table-column
                    field="ownerName"
                    :title="$t('payment.ownerName')"
                  ></vxe-table-column>
                  <vxe-table-column
                    field="voucher"
                    :title="$t('payment.voucher')"
                  >
                    <template v-slot="{ row }">
                      <thumbnail-text :srcs="row.voucher" />
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="explain"
                    :title="$t('payment.explain')"
                  ></vxe-table-column>
                </vxe-table>
              </fieldset>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('text.log')" name="log">
          <div class="drawer-content with-tab">
            <div class="box">
              <el-timeline>
                <el-timeline-item
                  v-for="(log, index) in logs"
                  :key="index"
                  :timestamp="log.doAt"
                >
                  <span v-if="log.doBy != null" style="color: #909399">{{
                    log.doBy
                  }}</span>
                  <raw-html :content="log.content"></raw-html>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Currency from "@/components/Currency";
import ThumbnailText from "@/components/ThumbnailText";
import RawHtml from "@/components/RawHtml";
import Dropzone from "@/components/Dropzone";

import Bargain from "@/api/bargain.js";
import Log from "@/api/log.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    Currency,
    ThumbnailText,
    RawHtml,
    Dropzone,
  },
  data() {
    return {
      activeName: "detail",
      bargain: {},
      logs: [],
    };
  },
  mounted() {
    // 根据id请求bargain
  },
  created() {
    const self = this;
    self.handleClickTab();
  },
  methods: {
    handleClickTab(tab, event) {
      if (this.activeName == "detail") {
        this.getBargain();
      }
      if (this.activeName == "log") {
        this.getLogs();
      }
    },
    getBargain() {
      const self = this;
      self.loadingStart();
      Bargain.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.bargain = res.data.entity;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },

    //
    getLogs() {
      const self = this;
      Log.forEntity("Bargain", self.id).then(function (res) {
        self.logs = res.data;
      });
    },

    //添加编辑收款或者变更拥有者后触发事件
    //this.$emit('updated', this.bargain);
  },
};
</script>